<template>
    <div>
        <div class="leftBox">
            <div class="leftBox_top">
                <div class="record_num">
                    <div>
                        <div class="record_num_box">
                            <div><span>{{elCarouselList.bidopenCount}}</span> 宗</div>
                            <div>{{dateName}}</div>
                        </div>
                        <div class="record_num_des">待开标监管数量</div>
                    </div>
                    <div>
                        <div class="record_num_box">
                            <div><span>{{elCarouselList.evalCount}}</span> 宗</div>
                            <div>{{dateName}}</div>
                        </div>
                        <div class="record_num_des">待评标监管数量</div>
                    </div>
                    
                </div>
                <div class="time_box">
                    <Acalender
                            :dateType.sync="elCarouselList.dateType"
                            :calendarListData.sync="calendarListData"
                            :currentHandleCarouseType.sync="currentHandleCarouseType"
                            @calenderDateChange="calenderDateChange">
                    </Acalender>
                </div>
            </div>
            <div class="leftBox_bottom">
                <card-list
                         :cardList.sync="cardDataList"
                         :total.sync="cardTotal"
                         :cardPageIndex.sync="cardPageIndex"
                         @queryCardListMore="queryCardListMore"
                         @openBidWitnessDetail="router_toOpen"/>
            </div>
        </div>
    </div>
</template>
<script>
import Acalender from '@/views/modules/traddingWitness/openBidWitness/components/Acalender.vue'
import {getRangeCount,getCalendarCount, queryOpenEvalList} from '@/server/bidOpenEvalWitness';
  import {addMonth} from '@/utils/index';
    import CardList from './CardList.vue'
export default {
    data(){
        return{
            calendarListData:[],
            currentHandleCarouseType:null, // 操作日历组件时记录轮播组件的查询状态 状态分为 日  周 月 全部
            elCarouselList:{
                bidopenCount:0,
                evalCount:0,
                dateType:this.formatDate(new Date(),'yyyy-MM-dd'),
                dateTypeName:'今日',
            },
            currentHandleCarouseCopy:{
                bidopenCount:0,
                evalCount:0,
                dateType:this.formatDate(new Date(),'yyyy-MM-dd'),
                dateTypeName:'今日',
            },
            dateName:'',
            cardDataList:[],
            cardTotal:0,
            cardPageIndex:1,
        }
    },
    components:{
        Acalender,
        CardList
    },
    created(){
        this.getCalendarCountFn();
        // 获取开评标项目数据 （默认为今日）
    this.queryOpenEvalListFn(this.formatDate( new Date(),'yyyy-MM-dd'));
    },
    methods:{
        // 获取日历开评标数据状态
        getCalendarCountFn(){
            let now  = new Date();
            let startTime = this.formatDate(addMonth(now,-1),'yyyy-MM');
            let endTime = this.formatDate(addMonth(now,1),'yyyy-MM');

            getCalendarCount({startTime:startTime,endTime:endTime}).then((res)=>{
                if(res.data.code=='1'){
                    this.calendarListData = res.data.data;
                    this.currentHandleCarouseType = this.elCarouselList.dateType;
                    var date=(this.elCarouselList.dateType.substring(5,this.elCarouselList.dateType.length)).split('-')
                    this.dateName=date[0]+'月'+date[1]+'日';
                    this.getOpenEvalBidRangeCount(this.elCarouselList.dateType)
                }else{
                    this.calendarListData || [];
                }
            })
        },
        calenderDateChange(date,dateType){
            if(!this.currentHandleCarouseType){
                this.currentHandleCarouseType = dateType;
            }
            var dates=(dateType.substring(5,dateType.length)).split('-')
            this.dateName=dates[0]+'月'+dates[1]+'日';

            let dateTime = this.formatDate(date,'yyyy-MM-dd');
            this.currentHandleSelectDate = dateTime;
            this.getOpenEvalBidRangeCount(dateTime)
        },
        getOpenEvalBidRangeCount(dateType){
            let dateTypeCopy = dateType;
            getRangeCount({
                type:dateType.indexOf('-')>0?'day':dateType , // 类型 day天 week周 month月 all为全部
                day:dateType.indexOf('-')>0?dateType:this.formatDate(new Date(),'yyyy-MM-dd'),
                deptCode:''
            }).then((res)=>{
                if(res.data.code=='1'){
                if(this.currentHandleCarouseType && this.currentHandleCarouseCopy){ // 轮播组件里的日历点击事件 赋值
                    dateTypeCopy = this.currentHandleCarouseType;
                }
                if(dateTypeCopy.indexOf('-') > 0 ){
                    this.elCarouselList.bidopenCount = res.data.data.bidopenCount || 0;
                    this.elCarouselList.evalCount = res.data.data.evalCount || 0;
                }
                this.queryOpenEvalListFn(dateType)
                }
            }).finally(()=>{})
        },
        // 卡片轮播加载更多数据
        queryCardListMore(pageIndex){
            this.cardPageIndex = pageIndex;
            let dateOrType = this.chartClickCarouseType || (this.search.dateRange.length > 0?this.search:false) || this.formatDate( new Date(),'yyyy-MM-dd')
            this.queryOpenEvalListFn(dateOrType)
        },
        // 获取待开评标数据
        queryOpenEvalListFn(dateTypeOrSearch,chartClick){
            // dateTypeOrSearch  dateType轮播日历点击记录卡片当前的状态 Search 搜索过滤框查询条件 ，chartClick 水晶球点击状态

            if(chartClick){
                this.chartClickCarouseType = dateTypeOrSearch;
                this.search.superviseDeptCode = '';
                this.search.bidName = '';
                this.search.bidCode = '';
                this.search.dateRange = [];
            }

            let params = {
                page:chartClick?1:this.cardPageIndex,
                rows:this.cardPageSize,
                filter:{
                    "bidName":dateTypeOrSearch.bidName || '', //项目名称
                    "bidCode":dateTypeOrSearch.bidCode || '',
                    startTime:dateTypeOrSearch.dateRange && dateTypeOrSearch.dateRange[0]?(this.formatDate( dateTypeOrSearch.dateRange[0],'yyyy-MM-dd') + ' 00:00:00'):'',
                    endTime:dateTypeOrSearch.dateRange && dateTypeOrSearch.dateRange[1]?(this.formatDate( dateTypeOrSearch.dateRange[1],'yyyy-MM-dd') + ' 23:59:59'):'',
                    superviseDeptCode:dateTypeOrSearch.superviseDeptCode || '' ////所属机构
                },
                searchKey:'',
            }

            let today = this.formatDate( new Date(),'yyyy-MM-dd');
            // 月，周，日，三种状态的卡片或列表数据查询参数处理 查询全部不处理，如果未传参数，后端默认会以今日为开始时间查询全部待开评标数据
            if(dateTypeOrSearch && (typeof dateTypeOrSearch == 'string') && dateTypeOrSearch != 'all'){
                if(dateTypeOrSearch == 'month'){
                params.filter.startTime = today + ' 00:00:00'
                params.filter.endTime = getCurrentMonthLastDay(today) + ' 23:59:59';
                }else if(dateTypeOrSearch == 'week'){
                params.filter.startTime = today + ' 00:00:00';
                params.filter.endTime = getCurrentWeekLastDay(today) + ' 23:59:59';
                }else{
                params.filter.startTime = dateTypeOrSearch + ' 00:00:00';
                params.filter.endTime = dateTypeOrSearch + ' 23:59:59';
                }
            }
            queryOpenEvalList(params).then((res)=>{
                if(this.chartClickCarouseType && !chartClick){ // 水晶球点击记录状态时，搜索更多卡片数据是concat形式赋值数据
                    this.cardDataList = this.cardDataList.concat(res.data.rows);
                }else{
                    let data = res.data.rows
                    this.cardDataList = data;
                }
                // 初始化页面时如果没有当天的开评标项目，默认关闭卡片展示
                if(this.initFlag && this.cardDataList.length == 0){
                    this.initFlag = false;
                    this.moreOpenItem = false;
                }
                this.cardTotal = res.data.total;
            })
        },
        //跳转到开评标监督
        router_toOpen(item,type) {
            let route_name = "";
            let route_path = '';



            if(type == 'openEdit'){
                route_name = 'openBidWitness_detail';
                route_path = '/traddingWitness/openBidWitness/open_detail';
            }
            if(type == 'openView'){
                route_name = 'openBidWitness_view';
                route_path = '/traddingWitness/openBidWitness_his/open_view';
            }
            if(type == 'evalEdit'){
                route_name = 'estimateBidWitness_detail';
                route_path = '/traddingWitness/openBidWitness/eval_detail';
            }
            if(type == 'evalView'){
                route_name = 'estimateBidWitness_view';
                route_path = '/traddingWitness/openBidWitness_his/eval_view';
            }

            window.open(route_path + '?bidCode='+item.bidCode+'&businessType=GC');


            // removeTabHandle(route_name)
            // window.opener.postMessage(
            //     {
            //         type:true,url:route_name,parent:'expertWitness_list',
            //         query:{
            //             bidCode:item.bidCode,
            //             businessType:'GC'
            //         }
            //     }, '*')
            // window.close()

        },
    }
}
</script>
<style lang="scss" scoped>
.leftBox{
    margin-right: 24px;
    width: 450px;
    height: 100%;
    .leftBox_top{
        width: 100%;
        height: 508px;
        background: linear-gradient(180deg, rgba(24, 144, 250, 0.3) 0%, rgba(24, 144, 250, 0.1) 26%, rgba(24, 144, 250, 0) 100%);
        overflow: hidden;
    }
    .record_num{
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        margin-top: 32px;
        &>div{
            text-align: center;
            &:nth-of-type(1){
                margin-right: 44px;
            }
        }
        .record_num_box{
            width: 180px;
            height: 139px;
            background: url('../../../../../assets/img/cockpit/record/record.png');
            text-align: center;
            padding-top: 37px;
            &>div:nth-of-type(1){
                color: #ffffff;
                span{
                    font-size: 28px;
                    font-family: DIN-Bold, DIN;
                    font-weight: bold;
                    height: 34px;
                    // width: 33px;
                    display: inline-block;
                }
            }
            &>div:nth-of-type(2){
                color: #66FFFF;
                line-height: 16px;
                height: 18px;
                font-size: 14px;
                margin-top: 5px;
            }
        }
        .record_num_des{
            margin-top: 26px;
            color: rgba(255, 255, 255, 0.85);
        }
    }
    .time_box{
        margin-top: 44px;
        margin-left: 16px;
    }
    .attendanceCalendar{
        width: 418px;
        height: 247px;
        background: linear-gradient(180deg, rgba(24,144,255,0.1) 0%, rgba(24,144,255,0.1) 100%);
        box-shadow: 0px 0px 8px 1px rgba(72, 92, 109, 0.2);
        /deep/ .ant-fullcalendar-cell{
            .ant-fullcalendar-value{
                color: rgba($color: #ffffff, $alpha: 0.8);
            }
        }
        /deep/ .ant-fullcalendar-last-month-cell{
            .ant-fullcalendar-value{
                color: rgba($color: #ffffff, $alpha: 0.3);
            }
        }
        /deep/ .ant-fullcalendar-disabled-cell{
            .ant-fullcalendar-value{
                color:rgba(152,149,149 ,80%);
            }
        }
        /deep/ .ant-fullcalendar-month{
            .ant-fullcalendar-value{
                color: rgba($color: #ffffff, $alpha: 0.8);
            }
        }
        
        /deep/ .ant-fullcalendar table{
            height: 100%;
        }
        /deep/ .ant-fullcalendar-column-header{
            color: rgba($color: #ffffff, $alpha: 0.8);
        }
        /deep/ .ant-fullcalendar-tbody{
            margin-top: 10px;
        }
        /deep/ .ant-fullcalendar-value:hover{
            background-color: rgba(24,144,255,1);
        }
        /deep/ .ant-fullcalendar-calendar-body{
            padding: 14px 12px;
        }
        /deep/ .ant-fullcalendar{
            border-top: 1px solid #17528d;
        }
        /deep/ .ant-select-selection{
            background-color:#17528d;
            border: 1px solid #1890FF;
        }
        /deep/ .ant-select-arrow,/deep/ .ant-select{
            color: #ffffff;
        }
        /deep/ .ant-radio-button-wrapper{
            background-color: #17528d;
            border: none;
            color: #ffffff;
        }
        /deep/ .ant-radio-button-wrapper-checked{
            background-color: #FFC00A;
            
        }
    }
    /deep/ .el-carousel__arrow:hover{
        background-color: #1a77e2;
    }
    /deep/ .el-carousel__arrow{
        background-color: rgba($color: #1a77e2, $alpha: 0.5);
    }
    /deep/ .el-button{
        border: 1px solid #1890FF;
        color: #1890FF;
    }
    /deep/ .el-button:hover{
        background: #1890FF;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        border: 1px solid #1890FF!important;
        color: #ffffff!important;
    }

}
    
</style>